module.exports = __webpack_public_path__ + "static/p09_pajaroRAla-5ed615d5633623f56d3b357f54fc6d9f.png";